var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmex = function SvgAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.893.667v18.666H19.56v-2.958h-2.252l-1.16-1.282-1.165 1.282H7.558V10.4H5.16l2.973-6.727h2.867l1.023 2.305V3.673h3.549l.616 1.737.62-1.737h2.75V.667H.894Zm16.395 3.888-1.213 3.391-1.205-3.39h-2.31V10h1.46V6.189l1.39 3.81h1.299l1.39-3.818V10h1.46V4.555h-2.271Zm-8.725 0L6.337 10H7.85l.418-1.09h2.318l.425 1.09h1.549l-2.226-5.445H8.563Zm.886 1.556.777 1.556H8.671l.778-1.556ZM17.652 10l-1.584 1.742L14.499 10h-1.94l2.55 2.722-2.55 2.722h1.886l1.592-1.758 1.584 1.758h1.939l-2.565-2.738L19.56 10h-1.908Zm-9.76 0v5.444h4.668v-1.26H9.389v-.848h3.092v-1.228H9.39v-.848h3.17V10H7.894Zm10.112 3.104 1.556 1.563v-3.112l-1.556 1.55Z",
    fill: "#0071D7"
  })));
};
export default SvgAmex;